import { apiPost } from './conserv';

// Pontos de uso configurados no ADM (Sistema > Inteligência artificial): cada um tem modelo, prompt e limites próprios
export const USO_IA_CHAT = 'user_chat';
export const USO_IA_ANALISE_LICITACAO = 'user_analise_licitacao';

/**
 * Envia mensagens para o assistente IA via backend (o modelo é escolhido no ADM)
 * @param {Array} mensagens - Array de { papel: 'usuario'|'assistente', texto: string }
 * @param {string} uso - ponto de uso (USO_IA_CHAT, USO_IA_ANALISE_LICITACAO)
 */
export async function chatIa(mensagens, uso = USO_IA_CHAT) {
    return await apiPost('api/Ia/chat', { uso, mensagens });
}
